import React from 'react';

type TblFltInputTextProps = {
    id: string;
    val: string;
    onFilter: (val: string) => void;
};

const TableFltInputText = ({ id, val, onFilter }: TblFltInputTextProps): JSX.Element => {
    return (
        <input
            id={id}
            type="text"
            value={val}
            onChange={e => onFilter(e.target.value)}
        />
    );
};

export default TableFltInputText;
